import React from 'react';
import {
  Navigate,
  Routes,
  Route,
  useLocation,
} from 'react-router-dom';
import AdminPanel from '../admin/AdminPanel';
import Home from '../sections/Home';
import FootballUkraine from '../sections/FootballUkraine';
import SubsectionContent from '../subsections/SubsectionContent';
import EuroCups from '../sections/EuroCups';
import Tournaments from '../sections/Tournaments';
import Sports from '../sections/Sports';
import Biathlon from '../sections/Biathlon';
import NewsDetails from '../news/NewsDetails';
import ProfilePage from '../profile/ProfilePage';
import SearchResults from '../components/SearchResults';
import RequireAuth from '../components/RequireAuth';
import Championships from '../sections/Championships';
import About from '../info/About';
import Contacts from '../info/Contacts';
import PrivacyPolicy from '../info/PrivacyPolicy';
import Archive from '../components/Archive';
import AuthorsRankingPage from '../pages/AuthorsRankingPage';
import AllNewsPage from '../sections/AllNewsPage';
import ScrollToTop from '../components/ScrollToTop';
import { newsSectionRoutes } from '../config/newsSectionRoutes';
import { FC_KHARKIV } from '../config/teamAliases';
import NotFound from './NotFound';
import PageSeo from '../components/seo/PageSeo';
import PublicPageLayout from '../components/PublicPageLayout';

const Main = () => {
  const location = useLocation();
  const isAdminRoute = location.pathname === '/admin'
    || location.pathname.startsWith('/admin/');

  const routes = (
    <Routes>
      <Route path="/" element={<Home />} />

      <Route path="/football-ukraine" element={<FootballUkraine />} />
      <Route path="/championships" element={<Championships />} />
      <Route path="/eurocups" element={<EuroCups />} />
      <Route path="/biathlon" element={<Biathlon />} />
      <Route path="/sports" element={<Sports />} />
      <Route path="/tournaments" element={<Tournaments />} />

      {newsSectionRoutes.map(({ path, section, category }) => (
        <Route
          key={path}
          path={path}
          element={<SubsectionContent section={section} category={category} />}
        />
      ))}
      {FC_KHARKIV.legacyRoutes.map((path) => (
        <Route
          key={path}
          path={path}
          element={<Navigate to={FC_KHARKIV.route} replace />}
        />
      ))}

      <Route path="/news" element={<AllNewsPage />} />
      <Route path="/news/:id" element={<NewsDetails />} />
      <Route path="/search" element={<SearchResults />} />
      <Route path="/profile/:userId" element={<ProfilePage />} />

      <Route path="/about" element={<About />} />
      <Route path="/contacts" element={<Contacts />} />
      <Route path="/authors-ranking" element={<AuthorsRankingPage />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/archive" element={<Archive />} />

      <Route
        path="/admin"
        element={
          <>
            <PageSeo
              title="Адмін-панель | BigSPORT"
              description="Адміністративна панель BigSPORT."
              canonicalPath="/admin"
              robots="noindex, nofollow"
            />
            <RequireAuth allowedRoles={['admin', 'author']}>
              <AdminPanel />
            </RequireAuth>
          </>
        }
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );

  return (
    <>
      <ScrollToTop />

      {isAdminRoute ? (
        <div className="container">{routes}</div>
      ) : (
        <PublicPageLayout>{routes}</PublicPageLayout>
      )}
    </>
  );
};

export default Main;
